import $ from 'jquery';
  // A $( document ).ready() block.
  $( document ).ready(function() {

    // var id = $('.vertical-home-buttonset a').attr('id');
    // console.log(id);

    $('.vertical-home-buttonset .btn').click(function() {
      // console.log(this);
      var dataLink = '#' + $(this).attr('data-link');
      // console.log('click....' + dataLink);
      $(dataLink).scrollHere();
    });

  });
  export default scrollTo;




// WEBPACK FOOTER //
// ./scripts/util/ScrollTo.js